import { observer } from 'mobx-react'
import React from 'react'
import { ExternalLink } from 'shared-components/ExternalLink/ExternalLink'
import { BlogStore } from 'bzx-common/src/stores'
import BlogPostPlaceholder from './BlogPostPlaceholder'

const placeholder = <BlogPostPlaceholder />

export function BlogPosts({ blogStore }: { blogStore: BlogStore }) {
  const showLoader = !blogStore.posts.loaded && !blogStore.posts.error
  return (
    <div className="lobby__blog-posts panel--simple">
      <h3 className="title-section lobby__widget-header padded-1 flex-row-center">
        Latest blog posts
      </h3>
      <div className="padded-h-1 padded-bottom-1">
        <div className="blog-posts">
          {showLoader && placeholder}
          {blogStore.latestPosts.length > 0 &&
            blogStore.latestPosts.map((post, index) => {
              return (
                <div className="blog-posts__a" key={index}>
                  <ExternalLink href={post.url}>
                    <img
                      src={post.image}
                      title={post.title}
                      className="blog-posts__img panel--simple"
                      loading="lazy"
                    />
                  </ExternalLink>

                  <div>
                    <ExternalLink href={post.url}>
                      <p className="margin-top-1 txt-size-12 txt-default">{post.title}</p>
                    </ExternalLink>

                    <p className="margin-0 txt-subtitle">{post.date}</p>
                  </div>
                </div>
              )
            })}
          {blogStore.posts.error && <p className="txt-warning">{blogStore.posts.error.message}</p>}
        </div>
      </div>
    </div>
  )
}

export default observer(BlogPosts)
